import goldIcon from '../../../assets/ic_goldstart.png';
import platIcon from '../../../assets/ic_partner.png';
import storeGroupIcon from '../../../assets/storeIcon.png';
import onlOffGroupIcon from '../../../assets/web_hi_res_512.png';
import emptyCart from '../../../assets/emptyCart.png';
import Spinner from 'components/contentLoader/spinner';

export type ExpiredRewardProps = {
    expiredRewardList?: Array<Record<string, unknown>>;
    isLoading?: boolean;
};

export default function ExpiredReward({ expiredRewardList, isLoading }: ExpiredRewardProps) {
    const couponList =
        expiredRewardList && expiredRewardList.length
            ? expiredRewardList.map((listItem, index) => {
                  let segmentCode: string | null = null;
                  if (listItem.SegmentCode == 'PLAT') {
                      segmentCode = platIcon;
                  } else if (listItem.SegmentCode == 'GOLD') {
                      segmentCode = goldIcon;
                  }
                  let groupCodeIcon: string | null = null;
                  if (listItem.SegmentCode == 'ONL') {
                      groupCodeIcon = onlOffGroupIcon;
                  } else {
                      groupCodeIcon = storeGroupIcon;
                  }
                  return (
                      <div className="row" key={index}>
                          <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                              <div className="card card-pd card-mr">
                                  <div className="row">
                                      <div className="col-xs-2 col-sm-3 col-md-3 col-lg-3 img-Box">
                                          <img src={listItem.ImagePath as string} alt="" />
                                      </div>

                                      <div className="col-xs-10 col-sm-9 col-md-9 col-lg-9" style={{ padding: '3px 0px' }}>
                                          <section style={{ lineHeight: '16px' }}>
                                              <div className="card-text Fw primaryTextColor">{listItem.ProductName as string}</div>

                                              <span className="card-text F5 Mr-R">
                                                  {segmentCode !== null ? <img src={segmentCode} className="segmentIcon" alt="" /> : null}
                                                  {listItem.SupplierName as string}
                                              </span>

                                              <span className="card-text F5">
                                                  {groupCodeIcon !== null ? (
                                                      <img src={groupCodeIcon} style={{ height: 11 }} className="segmentIcon" alt="" />
                                                  ) : null}
                                                  {listItem.GroupName as string}
                                              </span>
                                          </section>

                                          <div className="row">
                                              <div className="col-sm-12 col-md-12 no-Pd">
                                                  <div className="flex-container-grid Lh-14">
                                                      <div className="card-text F4 colWidth-md pd-3 Lh-14" style={{ paddingLeft: '0px' }}>
                                                          Return Expire
                                                          <div className="card-text F4 no-Pd expDt">{listItem.ReturnExpireDate as string}</div>
                                                      </div>
                                                      <div className="card-text F4 colWidth-md pd-3 Lh-14">
                                                          Valid Upto
                                                          <div className="card-text F4 no-Pd vldDt">{listItem.ValidDate as string}</div>
                                                      </div>
                                                      {listItem.IsRedeemed ? (
                                                          <div className="card-text F4" style={{ padding: '3px 0px' }}>
                                                              <button type="submit" className="Redeem-btn">
                                                                  <span>Earned</span>
                                                                  <span>₹ {listItem.Reward as string}</span>
                                                              </button>
                                                          </div>
                                                      ) : (
                                                          <div className="card-text F4" style={{ padding: '3px 0px' }}>
                                                              <button
                                                                  type="submit"
                                                                  className="Redeem-btn"
                                                                  style={{ fontWeight: 'bold', backgroundColor: 'red' }}
                                                              >
                                                                  <span>Expired</span>
                                                                  <span>₹ {listItem.Reward as string}</span>
                                                              </button>
                                                          </div>
                                                      )}
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  {listItem.Description !== undefined && listItem.Description !== null && listItem.Description !== '' ? (
                                      <div className="collapseCard">
                                          <div className="col-md-12 col-sm-12 card-text F4 primaryTextColor no-Pd">{listItem.Description as string}</div>
                                      </div>
                                  ) : null}
                              </div>
                          </div>
                      </div>
                  );
              })
            : !isLoading && expiredRewardList && expiredRewardList.length === 0
              ? (
                    <>
                        <img src={emptyCart} className="emptyCart-img" alt="" />
                        <div className="emptyCart-txt">Oops ! No item in Reward...</div>
                    </>
                )
              : null;

    return (
        <div>
            <section className="rewardCardSection">
                {couponList}
                {isLoading ? <Spinner /> : null}
            </section>
        </div>
    );
}
